<div #refModalTrigger><ng-content select="[trigger]"></ng-content></div>
@if ((refModalTrigger.children.length === 0)) {
  <div>
    <button nz-button nzType="primary" type="button" (click)="showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>{{triggerTitle}}</span>
    </button>
  </div>
}
<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWidth="90%"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <app-add-edit-form #form [editObject]="object" (formFinished)="onFormFinished($event)"></app-add-edit-form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" type="button" (click)="handleCancel()">Abbrechen</button>
    @if (!object) {
      <button
        nz-button
        nzType="primary"
        type="button"
        (click)="handleOk()"
        [nzLoading]="isConfirmLoading"
      >Speichern</button>
    }
  </ng-template>
</nz-modal>
